'use strict';

var app = require('mag-app');


/**
 * Change favorite state.
 *
 * @param {Object} video - movie data
 */
module.exports = function ( video ) {
    video.changeFlags({favorite: !video.favorite}, function ( error ) {
        app.emit('change:favorite', {video: video, error: error});
    });
};
